import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import jQuery from 'jquery';
import { resolveReferences } from '../../utils';

export default {
  treeController: [
    'runtimeConstant',
    'webApiSettings',
    '$scope',
    '$rootScope',
    '$filter',
    '$state',
    'treeService',
    '$timeout',
    'authService',
    'EFeatures',
    '$uibModal',
    'EQuickAccessItems',
    'revisionListService',
    'ETreeItemTypes',
    function (
      runtimeConstant,
      webApiSettings,
      $scope,
      $rootScope,
      $filter,
      $state,
      treeService,
      $timeout,
      authService,
      EFeatures,
      uibModal,
      EQuickAccessItems,
      revisionListService,
      ETreeItemTypes
    ) {
      'strict';

      function onLoadFolder(event, idFolder) {
        if (idFolder === null || idFolder === undefined) {
          if (
            $scope.repositoriesPromise !== null &&
            $rootScope.selectedTreeItem === null &&
            $scope.treeItemId === null
          ) {
            $scope.repositoriesPromise.then(() => $scope.selectFolder());
          } else {
            $scope.selectFolder();
          }
        } else {
          $scope.loadFolder(idFolder);
        }
      }

      function onCloseSearch() {
        $scope.$broadcast(
          'loadFolder',
          $scope.user.userPreferences.IdLastFolder
        );
      }

      function onUpdateOldParent(event, oldPath) {
        var lstIds = oldPath.split('/');
        lstIds.splice(lstIds.length - 1, 1);
        var parent = $scope.repositories.filter(
          (item) => item.Id === Number(lstIds[0])
        )[0];
        lstIds.splice(0, 1);
        var idToUpdate = Number(lstIds[lstIds.length - 1]);
        $scope.updateOldParent(parent, lstIds, idToUpdate);
      }

      function onSetFolder(event, folder) {
        var lstIds = folder.path.split('/');
        var parent = $scope.repositories.filter(
          (item) => item.Id === Number(lstIds[0])
        )[0];
        lstIds.splice(0, 1);
        $scope.setFolder(folder, parent, lstIds);
      }

      function CallNotificationForMyDeadLines() {
        treeService.getExpiredNotification().then((data) => {
          $scope.value = data;
        });
      }

      function getUserPreferences(preferences) {
        if (typeof preferences !== 'undefined') {
          $scope.loadFolder(preferences.IdLastFolder);
        }
      }

      function setCanSendFiles(first) {
        var isAutologin = authService.authentication.email === 'autologin';
        $timeout(() => {
          if (
            first &&
            first.Features &&
            typeof first.Features !== 'undefined'
          ) {
            $rootScope.canSendFiles =
              !isAutologin &&
              (authService.isAdmin() ||
                first.Features.indexOf(EFeatures.SEND_DOCUMENT) >= 0);
          } else {
            $rootScope.canSendFiles = !isAutologin && authService.isAdmin();
          }
        }, 200);
      }

      function folderRemoved(item) {
        return (
          !item.removed && !(
            item.TreeItemType === ETreeItemTypes.DOCUMENT_TYPE ||
            item.TreeItemType === ETreeItemTypes.ADDITIONAL_FIELD)
        );
      }

      function updateOldParent(parent, lstIds, idToUpdate) {
        if (parent && parent.Id === idToUpdate) {
          var childs = parent.Children.filter((item) => !item.removed);
          if (!childs || childs.length === 0) {
            parent.IsOpen = false;
            parent.HasChildren = false;
          }
        } else {
          if (parent.Children) {
            parent = parent.Children.filter(
              (item) => item.Id === Number(lstIds[0])
            )[0];
            lstIds.splice(0, 1);
            $scope.updateOldParent(parent, lstIds, idToUpdate);
          }
        }
      }

      function setFolder(folder, parent, lstIds) {
        if (parent && parent.Id === folder.idParent) {
          if (parent.Children !== null && parent.Children !== undefined) {
            // get current folder looking in parent folder's children
            var currentTreeItem = parent.Children.filter(function (item) {
              return item.Id === folder.id;
            });

            // if exists, update data and add folder and confirm that parent has children
            if (currentTreeItem && currentTreeItem.length > 0) {
              folder.children = currentTreeItem[0].Children;
              folder.isOpen = currentTreeItem[0].IsOpen;
              folder.hasChildrens = currentTreeItem[0].HasChildrens;
            }
          } else {
            parent.Children = [];
          }
          // if not, only add folder and confirm that parent has children
          parent.Children.push($scope.asTreeItem(folder));
          parent.HasChildren = true;
          parent.IsOpen = true;

          // select current folder after creation
          $scope.selectFolderAfterCreate(folder);
        } else {
          // search for the ID in the chldren's parent folder
          // then run setFolder again recursively
          if (parent.Children) {
            parent = parent.Children.filter(function (item) {
              return item.Id === Number(lstIds[0]);
            })[0];
            lstIds.splice(0, 1);
            $scope.setFolder(folder, parent, lstIds);
          }
        }
      }

      function selectFolderAfterCreate(folder) {
        if ($rootScope.selectedTreeItem !== folder) {
          $rootScope.selectedTreeItem = folder;
        }

        $state.go('home.folder', {
          id: folder.id,
          page: $scope.getPage('home.folder'),
        });
        $rootScope.title = $scope.title + ' - ' + folder.name;

        $rootScope.$broadcast('treeItemSelected', folder);
      }

      function asTreeItem(folder) {
        var treeItem = {
          Id: folder.id,
          Name: folder.name,
          Acronym: folder.acronym,
          Path: folder.path,
          TreeItemType: ETreeItemTypes.FOLDER,
          CanManageFolder: folder.canManageFolder,
          CanCreateFolder: folder.canCreateFolder,
          Features: folder.features,
          Children: folder.children,
          HasChildren: folder.hasChildren,
          IsOpen: folder.isOpen,
          HasPermission: folder.hasPermission,
          IdParent: folder.idParent,
          HasChildrens: folder.hasChildrens,
          CanShow: function () {
            return true;
          },
        };
        return treeItem;
      }

      function loadTree() {
        $scope.repositories = [treeService.loadingItem];

        $scope.repositoriesPromise = treeService.getRepositories();

        $scope.repositoriesPromise.then(
          function (data) {
            data = resolveReferences(data);

            $scope.repositories = data;

            var first = {};

            first = $scope.repositories.find(function (rep) {
              return rep.TreeItemType === ETreeItemTypes.REPOSITORY;
            });
            if (authService.authentication.email === 'autologin') {
              if (
                $scope.repositories !== null &&
                $scope.repositories.length > 0
              ) {
                $scope.expandFolder($scope.repositories[0], null, true);
              }
              $timeout(function () {
                $scope.repositories.forEach(function (r) {
                  if (r !== $scope.repositories[0]) {
                    $scope.expandFolder(r);
                  }
                });
              }, 200);

              $rootScope.selectedTreeItem = null;
              $scope.treeItemId = null;
            } else if ($rootScope.selectedTreeItem !== null) {
              $scope.selectFolder($rootScope.selectedTreeItem);
            } else if ($scope.treeItemId !== null) {
              $scope.loadFolder($scope.treeItemId);
            } else if (
              $state.current.name !== 'home.search' &&
              $state.current.name.indexOf('modules.') < 0
            ) {
              $timeout(function () {
                if ($rootScope.user !== undefined) {
                  getUserPreferences($rootScope.user.userPreferences);
                }
              }, 200);
            }

            $scope.repositoriesPromise = null;
            $scope.setCanSendFiles(first);
            CallNotificationForMyDeadLines();
          },
          function () {
            $scope.repositoriesPromise = null;
            swal.fire({
              title: $filter('translate')('TREE LOAD ERROR'),
              text: $filter('translate')('TREE LOAD ERROR MSG'),
              icon: 'error',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: $filter('translate')('RETRY'),
              showLoaderOnConfirm: true,
              preConfirm: function () {
                return new Promise(function (resolve) {
                  $scope.loadTree();
                  resolve();
                });
              },
            });
          }
        );
      }

      function showDropDown(id) {
        if (id === -6) {
          return '#trashMenu';
        }

        return id !== -8 &&
          id !== -5 &&
          id !== -4 &&
          id !== -3 &&
          id !== -2 &&
          id !== -1
          ? '#treemenu'
          : '';
      }

      function getItemIcon(item) {
        // icons: repository, folder, doctype, additionalFields
        var icons = [
          'md-repository',
          'md-doc-folder',
          'md-doc-type',
          'md-add-fields',
          'md-loading',
        ];

        // icons: repositorio e pasta desabilitados
        var disabledIcons = [
          'md-repository-disabled',
          'md-folder-disabled',
          'md-doc-type',
          'md-add-fields',
          'md-loading',
        ];

        // icons: quickaccess, shared docs, none, checkout, trashcan, favoritos
        var quickAcess = [
          'md-flash-on',
          'md-share',
          'md-local-print-shop',
          'md-edit',
          'md-delete',
          'md-grade',
          'md-today',
        ];

        if (item.TreeItemType > 4) {
          return quickAcess[item.TreeItemType - 5];
        }

        // Pasta: ícone aberto se expandida ou selecionada
        if (item.TreeItemType === ETreeItemTypes.FOLDER) {
          if (!item.HasPermission) {
            return 'md-folder-disabled';
          }

          var isSelected =
            $rootScope.selectedTreeItem &&
            $rootScope.selectedTreeItem.Id === item.Id;

          if (item.IsOpen === true || isSelected) {
            return 'md-doc-folder-open';
          }

          return 'md-doc-folder';
        }

        if (item.HasPermission) {
          return icons[item.TreeItemType];
        }

        return disabledIcons[item.TreeItemType];
      }

      function expandFolder(folder, e, selectFirst) {
        if (e) e.stopPropagation();

        folder.IsOpen = folder.IsOpen === null ? true : !folder.IsOpen;

        const notEmpty = Array.isArray(folder.Children);
        const isAllFolders = (c) => c.TreeItemType !== ETreeItemTypes.LOADING;

        if (
          folder.HasChildren === false ||
          (notEmpty && folder.Children.every(isAllFolders))
        ) {
          return;
        }

        if (!notEmpty) {
          folder.Children = [];
        }

        const hasAnyFolder = folder.Children.some((c) => c.TreeItemType === ETreeItemTypes.LOADING);
        if (!hasAnyFolder) {
          folder.Children.push(treeService.loadingItem);
        }

        treeService.getChildren(folder).then(
          function (data) {
            data = angular.fromJson(data);

            // Remove null/duplicate items
            folder.Children = folder.Children.filter((c, i, self) => {
              if (!c) return false;
              const duplicates = self.filter(
                (item) => item && item.Id === c.Id
              );
              return duplicates.indexOf(c) === 0;
            });

            // Remove loading indicator
            folder.Children = folder.Children.filter(
              (c) => c !== treeService.loadingItem
            );

            // Add new children if not already present (based on TreeItemType & Id)
            data.forEach((d) => {
              const alreadyExists = folder.Children.some(
                (c) =>
                  c &&
                  c.Id === d.Id &&
                  c.TreeItemType !== ETreeItemTypes.DOCUMENT_TYPE &&
                  c.TreeItemType !== ETreeItemTypes.ADDITIONAL_FIELD
              );
              if (!alreadyExists) {
                folder.Children.push(d);
              }
            });

            // Assign a dynamic HasChildrens function
            folder.HasChildrens = function () {
              const notRemoved =
                folder.Children?.filter($scope.folderRemoved) || [];
              return folder.HasChildren && notRemoved.length > 0;
            };

            // Order children
            folder.Children = $filter('orderBy')(folder.Children, [
              '+TreeItemType',
              '+Name',
            ]);

            // Select the first permitted child, if required
            if (selectFirst) {
              const firstPermitted = folder.Children.find(
                (c) => c.HasPermission
              );
              if (firstPermitted) $scope.selectFolder(firstPermitted);
            }
          },
          function () {
            // Error handling
            swal.fire({
              title: $filter('translate')('CHILDREN LOAD ERROR'),
              text: $filter('translate')('CHILDREN LOAD ERROR MSG'),
              icon: 'error',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: $filter('translate')('RETRY'),
              showLoaderOnConfirm: true,
              preConfirm: () => {
                return new Promise((resolve) => {
                  $scope.expandFolder(folder, e);
                  resolve();
                });
              },
            });
          }
        );
      }

      function loadChildren(item, current) {
        // Esta vazio ?
        var notEmpty = item.Children !== undefined && item.Children !== null;
        var hasChildren = notEmpty;

        // Se não está vazio
        if (notEmpty) {
          var isAllFolders = item.Children.every(function (c) {
            return c.TreeItemType === ETreeItemTypes.LOADING;
          });

          // Está carregando ?
          hasChildren = isAllFolders;
        }

        // Verifica se o item está vazio ou carregando
        if (!hasChildren) {
          //Carrega os filhos
          item.Children = $filter('orderBy')(current.Children, [
            '+TreeItemType',
            '+Name',
          ]);
        }
      }

      function expandItems(idFolder, parent, repositories) {
        if (!parent) return;

        const repo = repositories.find((e) => e.Id === parent.Id);
        if (!repo) return;

        if (repo.Id === idFolder) {
          if (repo.Children?.length) {
            const list = repo.Children.filter((child) => !child.removed);
            if (list.length === 0) repo.HasChildren = false;
          }
          $scope.selectFolder(repo);
          return;
        }
        const hasRelevantChildren = repo.Children?.some(
          (e) => e.TreeItemType !== ETreeItemTypes.LOADING
        );

        if (repo.Children?.length && hasRelevantChildren) {
          repo.IsOpen = null;
          $scope.expandFolder(repo);

          if (repo.HasChildren && parent.Children) {
            $scope.expandItems(idFolder, parent.Children[0], repo.Children);
          }
        } else {
          $scope.expandItemsLoading(idFolder, parent, repositories);
        }
      }

      function expandItemsLoading(idFolder, current, items) {
        var toSelect = null;

        var repo = items.filter(function (e) {
          return e.Id === current.Id;
        })[0];
        if (current.Children) {
          if (repo.Children) {
            repo.Children.splice(0, 0, current.Children);
          } else {
            repo.Children = current.Children;
          }
        }

        while (current) {
          var item = items.filter(function (c) {
            return c.Id === current.Id;
          })[0];

          //Verifica se o item existe na tree
          if (item === undefined) {
            break;
          }

          item.IsOpen = null;
          $scope.expandFolder(item);

          if (item.Id === idFolder) {
            toSelect = item;
            $scope.selectFolder(toSelect);
          }

          var hasChildren = current.Children && current.Children.length > 0;

          // Vai pro proximo nivel dos itens carregados
          if (hasChildren) {
            var folders = current.Children.filter(function (c) {
              return c.TreeItemType !== ETreeItemTypes.LOADING;
            });
            current = folders[0];
          } else {
            current = null;
          }

          // Pega os filhos do item da tree
          items = item.Children;
        }
      }

      function recursiveExpandItems(idFolder, parent, list) {
        $scope.expandItems(idFolder, parent, list);
      }

      function loadFolder(idFolder) {
        if (!Array.isArray($scope.repositories)) {
          return;
        }

        if (idFolder < 0) {
          if (idFolder === EQuickAccessItems.TRASHCAN) {
            var trashItem = $scope.repositories.find(function (e) {
              return e.Id === idFolder;
            });

            if (trashItem) {
              $scope.selectFolder(trashItem);
            }

            return;
          }

          var quickAccessRoot = $scope.repositories.find(function (e) {
            return e.Id === -1;
          });

          if (
            !quickAccessRoot ||
            !Array.isArray(quickAccessRoot.Children)
          ) {
            return;
          }

          var toSelect = quickAccessRoot.Children.find(function (e) {
            return e.Id === idFolder;
          });

          if (toSelect) {
            $scope.selectFolder(toSelect);
          }

          return;
        }

        if ($state.current.name.indexOf('home') === -1) {
          return;
        }

        // Seleciona na hora o nó da tree (evita sumir no 1º clique)
        var nodeInTree = findTreeItemById($scope.repositories, idFolder);
        if (nodeInTree) {
          $rootScope.selectedTreeItem = nodeInTree;
        }
        // NÃO fazer: $rootScope.selectedTreeItem = null;

        treeService.getFolderWithAncestors(idFolder).then(function (parent) {
          if (
            parent &&
            Array.isArray($scope.repositories) &&
            $scope.repositories.length
          ) {
            $scope.recursiveExpandItems(
              idFolder,
              parent,
              $scope.repositories
            );

            $timeout(function () {
              var active = jQuery('#repositories li.active')[0];

              if (!active) {
                return;
              }

              var pos = jQuery(active).position();

              if (!pos) {
                return;
              }

              jQuery('.sidebar-inner').scrollTop(
                jQuery('.sidebar-inner').scrollTop() + pos.top - 50,
                200
              );

              jQuery('.sidebar-inner').scrollLeft(
                jQuery('.sidebar-inner').scrollLeft() + pos.left,
                200
              );
            }, 100);
          }

          if ($scope.treeItemId === idFolder && !parent) {
            $scope.selectFolder();
          }
        });

        if (!$rootScope.isTreeClick) {
          $timeout(function () {
            var active = jQuery('#repositories li.active')[0];

            if (!active) {
              return;
            }

            var pos = jQuery(active).position();

            if (!pos) {
              return;
            }

            jQuery('.sidebar-inner').scrollTop(
              jQuery('.sidebar-inner').scrollTop() + pos.top - 50,
              200
            );

            jQuery('.sidebar-inner').scrollLeft(
              jQuery('.sidebar-inner').scrollLeft() + pos.left,
              200
            );
          }, 500);
        }

        $rootScope.isTreeClick = false;

        treeService.getByIdFolder(idFolder).then(function (treeItem) {
          if (!treeItem) return;

          // Preferir sempre o nó da tree (mesma referência do ng-repeat)
          var node = findTreeItemById($scope.repositories, idFolder);
          if (node) {
            $rootScope.selectedTreeItem = node;
          } else if (
            !$rootScope.selectedTreeItem ||
            $rootScope.selectedTreeItem.Id !== idFolder
          ) {
            $rootScope.selectedTreeItem = treeItem;
          }
        });
      }

      function findTreeItemById(items, id) {
        if (!items || !items.length) return null;

        for (var i = 0; i < items.length; i++) {
          if (items[i].Id === id) {
            return items[i];
          }

          if (items[i].Children && items[i].Children.length) {
            var found = findTreeItemById(items[i].Children, id);
            if (found) return found;
          }
        }

        return null;
      }

      function trySelectFirst(treeItem) {
        var selected = null;
        var expanding = false;

        var exist = treeItem === null || treeItem === undefined;

        if (exist && $scope.repositories.length > 0) {
          var recursive = function (r) {
            if (selected !== null || expanding) {
              return;
            }

            if (r.Id > 0 && r.HasChildren === true) {
              if (r.Children !== null) {
                r.Children.forEach(function (f) {
                  if (selected !== null || expanding) {
                    return;
                  }

                  if (f.HasPermission) {
                    selected = f;
                  }
                });
              } else {
                $scope.expandFolder(r);
                expanding = true;
              }
            }
          };

          $scope.repositories.forEach(recursive);

          if (selected !== null) {
            treeItem = selected;
          } else {
            return;
          }
        }
      }

      function selectFolder(treeItem, isTreeClick) {
        $rootScope.isTreeClick = isTreeClick ? true : false;

        if (
          treeItem === null ||
          treeItem === undefined ||
          $state.current.name.indexOf('home') === -1
        ) {
          return;
        }

        $scope.trySelectFirst(treeItem);

        if (
          treeItem.TreeItemType === ETreeItemTypes.QUICK_ACCESS ||
          treeItem.TreeItemType === ETreeItemTypes.REPOSITORY
        ) {
          return $scope.expandFolder(treeItem, null);
        }

        // Comparar por Id (não por referência de objeto)
        if (
          !$rootScope.selectedTreeItem ||
          $rootScope.selectedTreeItem.Id !== treeItem.Id
        ) {
          $rootScope.selectedTreeItem = treeItem;
        }

        $scope.goTo(treeItem);
      }

      function goTo(treeItem) {
        //isso é para funcionar corretamente a paginação quando atualiza e quando clica em outro item na tree
        if (treeItem !== null && treeItem !== undefined) {
          switch (treeItem.Id) {
            case -4:
              $state.go('home.checkouts', {
                page: $scope.getPage('home.checkouts'),
              });
              break;
            case -2:
              $state.go('home.shareds', {
                page: $scope.getPage('home.shareds'),
              });
              break;
            case -3:
              $state.go('home.digitalizations', {
                page: $scope.getPage('home.digitalizations'),
              });
              break;
            case -5:
              $state.go('home.favorites', {
                page: $scope.getPage('home.favorites'),
              });
              break;
            case -6:
              $state.go('home.trashcan', {
                page: $scope.getPage('home.trashcan'),
              });
              break;
            case -7:
              $state.go('home.publicLinks', {
                page: $scope.getPage('home.publicLinks'),
              });
              break;
            case -8:
              $state.go('home.myDeadLines', {
                page: $scope.getPage('home.myDeadLines'),
              });
              break;
            default:
              $state.go('home.folder', {
                id: treeItem.Id,
                page: $scope.getPage('home.folder'),
              });
              break;
          }

          $rootScope.title = $scope.title + ' - ' + treeItem.Name;

          $rootScope.$broadcast('treeItemSelected', treeItem);
        }
      }

      function getPage(newState) {
        var p = $state.params.page ? $state.params.page : 1;
        var state = $state.current.name;
        return state === newState ? p : 1;
      }

      function move(folderId, ids, type) {
        if (type === 'docs') {
          $scope.messageTitle = $filter('translate')('MOVE DOCUMENTS');
          $scope.messageDescription = $filter('translate')(
            'CONFIRM MOVE DOCUMENTS'
          );
          $scope.messageCancel = 'CANCELAR';
          $scope.messageMove = 'MOVER';
          $scope.modalMove = uibModal.open({
            scope: $scope,
            animationEnabled: true,
            backdrop: 'static',
            templateUrl: '/views/modal/moveModal/moveModal.html',
            size: 'small',
            windowClass: 'modal-remove',
            resolve: {},
          });

          $scope.cancelButton = function () {
            $scope.modalMove.close();
          };

          $scope.moveModal = function () {
            revisionListService.move(ids, folderId).then(
              function () {
                revisionListService.hideDocuments(ids);
                $scope.modalMove.close();
              },
              function () {
                $scope.modalMove.close();
                $scope.messageTitle = $filter('translate')('ACCESS DENIED');
                $scope.messageDescription = $filter('translate')(
                  'UNAUTHORIZED CHANGE FOLDER'
                );
                $scope.messageCancel = 'FECHAR';
                $scope.errModal = uibModal.open({
                  scope: $scope,
                  animationEnabled: true,
                  backdrop: 'static',
                  templateUrl: '/views/modal/moveModal/moveErrorModal.html',
                  size: 'small',
                  windowClass: 'modal-remove',
                  resolve: {},
                });
                $scope.cancelButton = function () {
                  $scope.errModal.close();
                };
              }
            );
          };
        } else {
          swal.fire({
            title: $filter('translate')('DOCUMENT ALREADY IN CHECKOUT'),
            text: $filter('translate')('CONFIRM REPLACE CHECKOUT'),
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: $filter('translate')('NO'),
            confirmButtonText: $filter('translate')('YES'),
            showLoaderOnConfirm: true,
            preConfirm: function () {
              return new Promise(function (resolve) {
                treeService.move(ids[0], folderId).then(
                  function () {
                    resolve();
                  },
                  function () {
                    resolve();
                  }
                );
              });
            },
            allowOutsideClick: false,
          });
        }
      }

      function emptyTrash() {
        $scope.messageTitle = $filter('translate')('CONFIRM REMOVE');
        $scope.messageDescription = 'Essa operação não pode ser revertida.';
        $scope.messageForward = $filter('translate')('REMOVE');
        $scope.messageCancel = $filter('translate')('CANCEL');

        $scope.modalEmptyTrash = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/deleteModal/deleteModal.html',
          controller: 'trashCanController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {},
        });
      }

      function run() {
        try {
          var $stateParams = $state.params;
          $scope.repositories = [];
          $scope.repositoriesPromise = null;
          $rootScope.selectedTreeItem = null;
          $scope.treeItemId = null;
          $scope.title = null;
          $scope.findTreeItemById = findTreeItemById;

          if (webApiSettings.detailsCompany === 'abase') {
            $scope.title = 'Abs-DOC';
          } else if (webApiSettings.detailsCompany === 'hdoc') {
            $scope.title = 'H5 Soluções';
          } else if (webApiSettings.detailsCompany === 'digitaldoc') {
            $scope.title = 'Digitaldoc V4';
          } else if (webApiSettings.detailsCompany === 'rb') {
            $scope.title = 'RB';
          }

          if ($stateParams.treeItem) {
            switch ($stateParams.treeItem) {
              case 'checkouts':
                $rootScope.selectedTreeItem = {
                  Id: -4,
                  Name: 'CHECKOUTS',
                  TreeItemType: ETreeItemTypes.CHECKOUTS,
                  Features: [],
                  IsOpen: true,
                  HasPermission: true,
                };
                break;
              case 'shared':
                $rootScope.selectedTreeItem = {
                  Id: -2,
                  Name: 'SHARED DOCS',
                  TreeItemType: ETreeItemTypes.SHARED_DOCUMENTS,
                  Features: [],
                  IsOpen: true,
                  HasPermission: true,
                };
                break;
              case 'digitalizations':
                $rootScope.selectedTreeItem = {
                  Id: -3,
                  Name: 'DIGITALIZATIONS',
                  TreeItemType: ETreeItemTypes.PENDING_SCAN,
                  Features: [],
                  IsOpen: true,
                  HasPermission: true,
                };
                break;
              case 'favorites':
                $rootScope.selectedTreeItem = {
                  Id: -5,
                  Name: 'FAVORITES',
                  TreeItemType: ETreeItemTypes.FAVORITES,
                  Features: [],
                  IsOpen: true,
                  HasPermission: true,
                };
                break;
              case 'myDeadLines':
                $rootScope.selectedTreeItem = {
                  Id: -8,
                  Name: 'MYDEADLINES',
                  TreeItemType: ETreeItemTypes.MY_DOCS_EXPIRED,
                  Features: [],
                  IsOpen: true,
                  HasPermission: true,
                };
                break;
              default:
                $scope.treeItemId = $stateParams.treeItem;
                break;
            }
          }

          $scope.$on(
            'loadFolder',
            logWrapper(
              onLoadFolder,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.$on(
            'closeSearch',
            logWrapper(
              onCloseSearch,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.$on(
            'updateOldParent',
            logWrapper(
              onUpdateOldParent,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.$on(
            'setFolder',
            logWrapper(onSetFolder, runtimeConstant.isDebugControllersInternals)
          );
          $scope.setCanSendFiles = logWrapper(
            setCanSendFiles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.folderRemoved = logWrapper(
            folderRemoved,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updateOldParent = logWrapper(
            updateOldParent,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setFolder = logWrapper(
            setFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectFolderAfterCreate = logWrapper(
            selectFolderAfterCreate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.asTreeItem = logWrapper(
            asTreeItem,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadTree = logWrapper(
            loadTree,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showDropDown = logWrapper(
            showDropDown,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getItemIcon = logWrapper(
            getItemIcon,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.expandFolder = logWrapper(
            expandFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadChildren = logWrapper(
            loadChildren,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.expandItems = logWrapper(
            expandItems,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.expandItemsLoading = logWrapper(
            expandItemsLoading,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.recursiveExpandItems = logWrapper(
            recursiveExpandItems,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadFolder = logWrapper(
            loadFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.findTreeItemById = logWrapper(
            findTreeItemById,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.trySelectFirst = logWrapper(
            trySelectFirst,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectFolder = logWrapper(
            selectFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goTo = logWrapper(
            goTo,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getPage = logWrapper(
            getPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.move = logWrapper(
            move,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.emptyTrash = logWrapper(
            emptyTrash,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
